// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {LoadingType} from 'common/util/workflow-timing';
import {
  ComponentLifetimeEndEventName,
  ComponentLifetimeStartEventName,
  trackTotalLifetime,
} from 'common/util/component-helpers';
import {panel2react} from 'common/util/react';

import {SpinnerColor, SpinnerSize, SpinnerTheme} from './types';
import {template} from './template';
import css from './index.inline.styl';

export interface SpinnerJsxProps {
  attrs?: {
    color?: SpinnerColor;
    size?: SpinnerSize;
    theme?: SpinnerTheme;
  };
}

export class Spinner extends Component<EmptyObj, SpinnerJsxProps[`attrs`]> {
  static get attrsSchema(): AttrsSchema<SpinnerJsxProps[`attrs`]> {
    return {
      ...super.attrsSchema,
      color: {type: `string`, enum: Object.values(SpinnerColor), default: SpinnerColor.Blue},
      size: {type: `string`, enum: Object.values(SpinnerSize), default: SpinnerSize.Small},
      theme: {type: `string`, enum: Object.values(SpinnerTheme), default: SpinnerTheme.Default},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }

  connectedCallback() {
    super.connectedCallback();
    trackTotalLifetime(this, {
      eventNames: {
        start: ComponentLifetimeStartEventName.LoadingAdded,
        end: ComponentLifetimeEndEventName.LoadingDisplayed,
      },
      props: {type: LoadingType.Spinner},
    });
  }
}

export const SpinnerEl = defineAndMakeJsxFactory<SpinnerJsxProps>(`mp-spinner`, Spinner);
export const SpinnerReact = panel2react<SpinnerJsxProps>(`mp-spinner`, Spinner);
